import React from "react";
import { NavLink } from "react-router-dom";
import ExamResultService from "../../../services/exam/ExamResultService";
import NotFoundDataInDate from "../../shared/not-found-data-in-date/NotFoundDataInDate";
import ExamRequestView from "../exam-request-view/ExamRequestView";
import './ExamRequest.scss';
import ExamRequestState, { ExamRequestProps } from "./ExamRequest.models";
import NotFoundExamImage from "../../../assest/images/UnderConstruction-Illustration.svg";

export default class ExamRequest extends React.PureComponent<ExamRequestProps, ExamRequestState> {
    examResultService: ExamResultService;
    constructor(props: any) {
        super(props);
        this.examResultService = new ExamResultService();
        this.state = {
            requestedExams: [],
            queryString: {
                descendingOrder: true,
                orderField: "requestId",
                pageSize: 1000,
                pageSkip: 0
            }
        };
    }

    componentDidMount() {
        let self = this;

        self.getData();
    }

    getData() {
        let self = this;
        this.examResultService.getExamsRequested(self.state.queryString).then(function (response) {
            self.setState({ requestedExams: response.rows });
        });
    }


    cancelRequest = (requestId?: number) => {
        let self = this;
        // eslint-disable-next-line no-restricted-globals
        if (confirm("آیا از لغو درخواست خود مطمئن هستید؟") && requestId != null) {
            this.examResultService.removeExamRequest(requestId).then(function (response) {

                if (response === 200 || response === 204) {
                    self.setState({ requestedExams: [] });
                    self.getData();
                }
            });
        }   
    }
    addExamRequest = () => { }

    render(): React.ReactNode {
        let removeRequest = this.cancelRequest;
        let requestedExams = this.state.requestedExams;
        
        let content;
        if(requestedExams.length > 0)
            content = (requestedExams.map(function (requestedExam, key) {
                return (
                    <ExamRequestView requestedExam={requestedExam} removeRequest={removeRequest} key={key} />
                )
            }));  
        else content = (
            <div style={{marginTop:'90px'}}>
                <NotFoundDataInDate config= {{height:"124",width:"230", subTitleClass:""}} image={NotFoundExamImage} title={"آزمونی ثبت نشده، شما برای شرکت در آزمون باید روی افزودن آزمون کلیک کنید."}/> 
            </div>
        )

        return <>
            {content}
            <div className="col-12 loc-bottom exam-request-area">
                <NavLink to={"/RequestExam"} className="btn btn-primary col-12 ">
                    افزودن آزمون
                </NavLink>
            </div>
        </>;
    }
}